// extracted by mini-css-extract-plugin
export default {"greeting":"Header_greeting__ultkK"};